export default __webpack_public_path__ + "static/media/lionfish.b2f9e55f.png";